import AuthenticatedResource from 'resources/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class ClientFieldAnswerResource extends AuthenticatedResource {
  static urlRoot = '/organization/:organization/clients/:client_id/client_fields_answers';

  id                = undefined;
  client_fields     = []; 

  pk() {
    return this.id && this.id.toString();
  }
}
